import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button, PolicyRow, Typography } from 'components/alf-design';
import { formats } from 'utils';

const PolicyCancelled = ({ agent, handleHistoryClick, status }) => {
  return (
    <Card>
      <Typography type="h2" component="h2" className="mb-[24px]">
        Billing
      </Typography>

      <div className="bg-legacy-errorBackground border border-legacy-errorBorder p-[13px] rounded-[8px] mb-[16px]">
        <Typography type="error">
          {status === 'cancelled'
            ? 'This policy has been cancelled. For billing questions or additional information, please contact your agent.'
            : `This policy is ${status}. For billing information, please contact your agent.`}
        </Typography>
      </div>
      <div>
        <div className="grid grid-cols-2 gap-[12px] mb-[16px]">
          <PolicyRow
            label="Agency Name"
            value={agent.organizationName}
            vertical
          />
          <PolicyRow
            label="Agency Phone Number"
            value={formats.phoneFormat(agent.phone)}
            vertical
          />
        </div>
        <div>
          <Button
            id="payment-history-button"
            data-dd-action-name="dashboard.billing.cancelled_policy_payment_history"
            onClick={handleHistoryClick}
            className="w-full"
            type="secondary"
          >
            Payment History
          </Button>
        </div>
      </div>
    </Card>
  );
};

PolicyCancelled.propTypes = {
  agent: PropTypes.object,
  handleHistoryClick: PropTypes.func,
  status: PropTypes.string,
};

export default PolicyCancelled;
